import { React, useEffect, useContext, useState } from "react";
import { StoreContext } from "components/StoreContext";
import Loading from "components/Loading";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDoubleRight, faTimes } from "@fortawesome/free-solid-svg-icons";
import {
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Input,
  InputGroup,
  Modal,
  ModalHeader,
  ModalBody
} from "reactstrap";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";

const ProductCards = ({ bundleCount, courseId }) => {
  const [product, updateProduct] = useState([]);
  const [productList, updateProductList] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const { store, StoreAPI } = useContext(StoreContext);
  const [loading, updateLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [selected, setSelected] = useState("Featured");
  const [sortOpen, setSortOpen] = useState(false);
  const [visible, setVisible] = useState(9);

  const toggle = () => setModal(!modal);

  const closeBtn = (
    <Button type="link" className="close" color="default">
      <FontAwesomeIcon icon={faTimes} />
    </Button>
  );

  const expandModal = card => {
    setSelectedCard(card);
    toggle();
  };

  const closeModal = () => {
    setSelectedCard();
    toggle();
  };

  const createKey = title => {
    const arr = title;
    return arr[0];
  };

  useEffect(() => {
    if (store.loaded) {
      StoreAPI.get(`products/${courseId}/bundle`).then(response => {
        updateLoading(false);
        const data = response.data.map((d, idx) => ({
          ...d,
          key: createKey(d.title),
          index: idx
        }));
        updateProduct(data);
        updateProductList(data);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [store.loaded, courseId]);

  const searchItems = searchValue => {
    setSearchInput(searchValue || "");
  };

  useEffect(() => {
    if (searchInput === "") {
      updateProductList(product);
    }

    const results = product.filter(item => {
      return Object.values(item)
        .join("")
        .toLowerCase()
        .includes(searchInput.toLowerCase());
    });

    updateProductList(results);
  }, [searchInput, product]);

  const setFilter = (event, type = null) => {
    setSelected(event.target.value);
    let sorted = productList.sort((a, b) => a.index - b.index);

    if (type === "asc") {
      sorted = productList.sort((a, b) => {
        if (a.key && b.key) {
          return a.key.localeCompare(b.key);
        }
        return 0;
      });
    } else if (type === "desc") {
      sorted = productList.sort((a, b) => {
        if (a.key && b.key) {
          return b.key.localeCompare(a.key);
        }
        return 0;
      });
    }
    updateProductList(sorted);
  };

  const loadMore = () => {
    setVisible(visible + 9);
  };

  return (
    <>
      <div className="titleSearch">
        <h4 className="title">{bundleCount} Courses Included</h4>
        <div className="titleSearch--block">
          <InputGroup className="titleSearch--block--searchBar">
            <Input
              placeholder="Search in Courses"
              name="filter"
              type="text"
              aria-label="search"
              onChange={e => searchItems(e.target.value)}
              id="titleSearch--input"
            />
          </InputGroup>
          <div className="products__results-sort">
            <ButtonDropdown
              isOpen={sortOpen}
              toggle={() => setSortOpen(!sortOpen)}
            >
              <DropdownToggle outline size="sm" color="primary" caret>
                <span>Filter:</span> {selected}
              </DropdownToggle>
              <DropdownMenu end>
                <DropdownItem
                  tabIndex="0"
                  role="menuitem"
                  value="Featured"
                  onClick={event => setFilter(event, "default")}
                >
                  Featured
                </DropdownItem>
                <DropdownItem
                  tabIndex="0"
                  role="menuitem"
                  value="Name A to Z"
                  onClick={event => setFilter(event, "asc")}
                >
                  Name A to Z
                </DropdownItem>
                <DropdownItem
                  tabIndex="0"
                  role="menuitem"
                  value="Name Z to A"
                  onClick={event => setFilter(event, "desc")}
                >
                  Name Z to A
                </DropdownItem>
              </DropdownMenu>
            </ButtonDropdown>
          </div>
        </div>
      </div>
      {productList.length >= 1 && (
        <div className="productCardBlock">
          {loading && (
            <div className="loadingHolder">
              <Loading />
            </div>
          )}

          {productList.length > 0 &&
            bundleCount === 2 &&
            productList.map(card => {
              return (
                <div className="productCard" key={card.hlcCourseId}>
                  <div className="productCard__overlay">
                    <div className="productCard__card--twoBundle">
                      <h5 className="productCard__card--title">{card.title}</h5>
                      <p
                        className="productCard__card--description"
                        dangerouslySetInnerHTML={{
                          __html: card.longDescription
                        }}
                      />
                    </div>
                    <div className="productCard__card--link">
                      <button
                        className="productCard__card--button"
                        type="button"
                        onClick={() => expandModal(card)}
                      >
                        Learn More{" "}
                        <FontAwesomeIcon
                          className="ms-1"
                          icon={faAngleDoubleRight}
                        />
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}

          {productList.length > 0 && (
            <>
              {bundleCount >= 3 &&
                bundleCount <= 9 &&
                productList.map(card => {
                  return (
                    <div className="productCard" key={card.hlcCourseId}>
                      <div className="productCard__overlay">
                        <div className="productCard__card">
                          <h5 className="productCard__card--title">
                            {card.title}
                          </h5>
                          <p className="productCard__card--description">
                            {card.longDescription.replaceAll(
                              /(<([^>]+)>)/gi,
                              ""
                            )}
                          </p>
                        </div>
                        <div className="productCard__card--link">
                          <button
                            className="productCard__card--button"
                            type="button"
                            onClick={() => expandModal(card)}
                          >
                            Learn More{" "}
                            <FontAwesomeIcon
                              className="ms-1"
                              icon={faAngleDoubleRight}
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </>
          )}

          {productList.length > 0 && (
            <>
              {bundleCount >= 10 &&
                productList.slice(0, visible).map(card => {
                  return (
                    <div className="productCard" key={card.hlcCourseId}>
                      <div className="productCard__overlay--noDescription">
                        <div className="productCard__card--noDescription">
                          <h5 className="productCard__card--title">
                            {card.title}
                          </h5>
                        </div>
                        <div className="productCard__card--link">
                          <button
                            className="productCard__card--button"
                            type="button"
                            onClick={() => expandModal(card)}
                          >
                            Learn More
                            <FontAwesomeIcon
                              className="ms-1"
                              icon={faAngleDoubleRight}
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </>
          )}
        </div>
      )}
      {productList.length === 0 && (
        <div className="text-center p-5">
          <h2 style={{ color: "#FFF" }}>Sorry. No matches were found!</h2>
        </div>
      )}
      {productList.length > 0 &&
        bundleCount >= 10 &&
        visible < productList.length && (
          <div className="viewMoreCourses">
            <Button
              onClick={loadMore}
              className="viewMoreCourses__button"
              type="button"
            >
              View More Courses
            </Button>
          </div>
        )}
      <Modal className="productCardModal" isOpen={modal} toggle={closeModal}>
        <ModalHeader
          className="productCardModal__header"
          onClick={toggle}
          close={closeBtn}
        >
          Course Details
        </ModalHeader>
        <ModalBody className="productCardModal__body">
          {selectedCard && <h5>{selectedCard.title}</h5>}
          <div className="courseTabs">
            <Tabs>
              <TabList>
                {selectedCard && selectedCard.longDescription && (
                  <Tab>Product Overview</Tab>
                )}
                {selectedCard && selectedCard.learningObjectives && (
                  <Tab>Learning Objectives</Tab>
                )}
                {selectedCard && selectedCard.author && (
                  <Tab>Author Information</Tab>
                )}
                {selectedCard && selectedCard.courseOutline && (
                  <Tab>Course Outline</Tab>
                )}
                {selectedCard && selectedCard.creditInfo && (
                  <Tab>Credit Info</Tab>
                )}
              </TabList>
              {selectedCard && selectedCard.longDescription && (
                <TabPanel>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: selectedCard.longDescription
                    }}
                  />
                </TabPanel>
              )}
              {selectedCard && selectedCard.learningObjectives && (
                <TabPanel>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: selectedCard.learningObjectives
                    }}
                  />
                </TabPanel>
              )}
              {selectedCard && selectedCard.author && (
                <TabPanel>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: selectedCard.author
                    }}
                  />
                </TabPanel>
              )}
              {selectedCard && selectedCard.courseOutline && (
                <TabPanel>
                  <p>{selectedCard.courseOutline}</p>
                </TabPanel>
              )}
              {selectedCard && selectedCard.creditInfo && (
                <TabPanel>
                  <p>{selectedCard.creditInfo}</p>
                </TabPanel>
              )}
            </Tabs>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

ProductCards.propTypes = {
  bundleCount: PropTypes.number,
  courseId: PropTypes.number
};

ProductCards.defaultProps = {
  bundleCount: false,
  courseId: null
};

export default ProductCards;
